import { render, staticRenderFns } from "./WorkspaceBuildHypothesesModal.vue?vue&type=template&id=006dc311&scoped=true"
import script from "./WorkspaceBuildHypothesesModal.vue?vue&type=script&lang=js"
export * from "./WorkspaceBuildHypothesesModal.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceBuildHypothesesModal.vue?vue&type=style&index=0&id=006dc311&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006dc311",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('006dc311')) {
      api.createRecord('006dc311', component.options)
    } else {
      api.reload('006dc311', component.options)
    }
    module.hot.accept("./WorkspaceBuildHypothesesModal.vue?vue&type=template&id=006dc311&scoped=true", function () {
      api.rerender('006dc311', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/revealKgWorkspace/WorkspaceBuildHypothesesModal.vue"
export default component.exports